import React from "react";
import { Input, Checkbox, Button ,Select,SelectItem} from "@nextui-org/react";

const Roleaccess = () => {
  return (
    <div className="main-inner-wrapper leavemenu-wrapper">
      <div className="px-4">
        <div className="leave-apply__wrapper p-4 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-gray-500 rounded-xl">
        <h1 className="incident-report-heading">Role Permission</h1>
          <div className="form-container">
            <form>
              <div className="form-row mb-4">
              <Select
                    label="Role"
                    className="custom-select"
                    labelPlacement="outside"
                    variant="bordered"
                    fullWidth
                  >
                    <SelectItem key=" Booking Agent" value=" Booking Agent">
                     Student
                    </SelectItem>
                    <SelectItem key="  Finance Manager" value="  Finance Manager">
                      Manager
                    </SelectItem>
                    <SelectItem key="Admin" value="Admin">
                      Admin
                    </SelectItem>
                  </Select>
              </div>

              <div className="mb-6">
                <div className="flex flex-col gap-1 font-bold">Student Module</div>
                <div className="form-row space-x-4">
                  <Checkbox>Create</Checkbox>
                  <Checkbox>Edit</Checkbox>
                  <Checkbox>View</Checkbox>
                  <Checkbox>Delete</Checkbox>
                </div>
              </div>

              <div className="mb-6">
                <div className="flex flex-col gap-1 font-bold">Canteen Module</div>
                <div className="form-row space-x-4">
                  <Checkbox>Create</Checkbox>
                  <Checkbox>Edit</Checkbox>
                  <Checkbox>View</Checkbox>
                  <Checkbox>Delete</Checkbox>
                </div>
              </div>

              <div className="mb-6">
                <div className="flex flex-col gap-1 font-bold">Dashboard</div>
                <div className="form-row space-x-4">
                  <Checkbox>View</Checkbox>
                </div>
              </div>

              <div className="mb-6">
                <div className="flex flex-col gap-1 font-bold">Role Access Config</div>
                <div className="form-row space-x-4">
                  <Checkbox>Edit</Checkbox>
                  <Checkbox>View</Checkbox>
                </div>
              </div>

              <div className="flex justify-center items-center gap-4 mt-4">
                <Button color="danger" variant="flat">
                  Cancel
                </Button>
                <Button className="incidentSubmitBtn" >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Roleaccess;
